'use strict';

import angular from 'angular';

import './style.css';


export default function(opts) {
	return function($window, $interpolate, $uibModal) {
		'ngInject';

		return {
			require: '^incident',
			link: postLink,
			scope: {
				$instance: '=instance',
				$context: '<context',
				$$permission: '<permission',
				templateUrl: '@',
			}
		};

		function postLink(scope, element, attrs, $incident) {
			scope.$incident = $incident;
			if (!scope.$context) scope.$context = {};

			var successUrl = element.attr('success-url')

			var modalOpts = {
				appendTo: angular.element($incident.parentElement),
				backdrop: 'static',
				controller: function() {},
				scope: scope,
				resolve: {
					curIncident: (incidents) => {
						'ngInject';
						if (opts.refreshIncident) {
							return incidents.get($incident, true);
						}
						return $incident;
					}
				},
			};
			angular.extend(modalOpts, opts);
			$incident.$ready.then(function() {
				if (scope.$$permission !== undefined && !scope.$$permission) {
					element.addClass('disabled');
					attrs.$set('disabled', true);
					return;
				}
				element.addClass('btn-rest');
				element.on('click', function() {
					this.blur();
					if (element.hasClass('busy')) return;
					// var message = 'This incident is not active, are you sure you want to make changes?';
					// if ($incident.completed != false && !confirm(message)) {
					// 	return;
					// }
					element.addClass('busy');
					if (scope.$instance) var instanceCopy = angular.copy(scope.$instance);
					// Make the incident, context and instance available in resolve
					// functions.  The $incident resolve function needs to be set here for
					// cases where there are multiple incident directives attached to the
					// same scope.
					if (!modalOpts.resolve) modalOpts.resolve = {};
					modalOpts.resolve.$incident = () => $incident;
					if (scope.$context) modalOpts.resolve.$context = () => scope.$context;
					if (scope.$instance) modalOpts.resolve.$instance = () => scope.$instance;
					if (scope.templateUrl) modalOpts.templateUrl = scope.templateUrl;
					// We pass the scope to the customTemplateUrl if it exists.  We then
					// define the template option using the output of this function.
					if (typeof opts.scopedTemplateUrl === 'function') {
						modalOpts.templateUrl = opts.scopedTemplateUrl(scope);
					}
					var modal = $uibModal.open(modalOpts);
					modal.opened.finally(function() {
						element.removeClass('busy');
					});
					modal.result.then(function closed(result) {
						if (scope.$instance) angular.merge(instanceCopy, result);

						if (successUrl) {
							var parsedSuccessUrl = $interpolate(successUrl)({
								$instance: scope.$instance,
								$context: scope.$context,
								$result: result,
							});
							$window.location.href = parsedSuccessUrl;
						}
					}, function rejected() {
						if (scope.$instance) angular.merge(scope.$instance, instanceCopy);
					});
				});
			});
		}
	}
}
